export default function mockStatus(mock) {
  mock.onGet(/api\/status/).reply(config => {
    return [200, { status: 'OK' }]
  })
}
